/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react'
import { useIntl } from 'react-intl'

import { Icon } from '@/components/common'

import InfoTable from './InfoTable'

export const Check = () => {
  const { formatMessage } = useIntl()
  return <Icon fill="success" name="check" title={formatMessage({ id: 'compareTable.included' })} />
}
export const X = () => {
  const { formatMessage } = useIntl()
  return <Icon fill="error" name="close" size="small" title={formatMessage({ id: 'compareTable.notIncluded' })} />
}

// @TODO consider using react-table
const CompareTable = () => (
  <InfoTable>
    <colgroup>
      <col />
      <col />
      <col />
    </colgroup>
    <tbody>
      <InfoTable.Header>
        <td style={{ backgroundColor: '#4955C4' }}><br /></td>
        <td>Standard Support</td>
        <td>VIP Service</td>
      </InfoTable.Header>
      <tr>
        <InfoTable.ShadedCell>Price</InfoTable.ShadedCell>
        <td>Included in base plan</td>
        <td>$50/year</td>
      </tr>
      <tr>
        <InfoTable.ShadedCell>Email & Chat Support</InfoTable.ShadedCell>
        <td><Check /></td>
        <td>Priority email & chat support</td>
      </tr>
      <tr>
        <InfoTable.ShadedCell>Phone Support</InfoTable.ShadedCell>
        <td><X /></td>
        <td>Priority phone support</td>
      </tr>
      <tr>
        <InfoTable.ShadedCell>Remote Support</InfoTable.ShadedCell>
        <td><X /></td>
        <td><Check /></td>
      </tr>
      <tr>
        <InfoTable.ShadedCell>Migration Support</InfoTable.ShadedCell>
        <td><X /></td>
        <td><Check /></td>
      </tr>
      <tr>
        <InfoTable.ShadedCell>1:1 Training</InfoTable.ShadedCell>
        <td><X /></td>
        <td>(2) 30-minute sessions/month</td>
      </tr>
      <tr>
        <InfoTable.ShadedCell>24/7 Access to our Knowledge Base</InfoTable.ShadedCell>
        <td><Check /></td>
        <td><Check /></td>
      </tr>
    </tbody>
  </InfoTable>
)

export default CompareTable
